module.exports = __webpack_public_path__ + "img/13.7d64bab5.png";